import { SessionPayload } from '../../session/types'

const getNameFromPayload = ({ firstName, lastName }: SessionPayload): string | undefined =>
  firstName && lastName && `${firstName} ${lastName}`

export default getNameFromPayload
